export enum OversellPolicy {
    REQUIRE_AVAILABILITY = "require_availability",
    ALLOW_NEGATIVE = "allow_negative",
}

export interface WareInventory {
    id: ID;
    seller: { id: ID };
    oversellPolicy: OversellPolicy;
    lowInventoryThreshold: number | null;
}

export interface WareInventoryLot {
    id: ID;
    inventory: WareInventory;
    count: number;
    unavailable: number;
    fulfilled: number;
    pendingFulfillment: number;
    returned: number;
    purchased: number; // fulfilled + pendingFulfillment + returned
    open: number; // count - unavailable - purchased
    createdAt: string;
}

// Lot shape returned by GET catalogItems?expand=inventory.inventoryLots
export interface InventoryLot {
    id: ID;
    count: number;
    available: number;
    reserved: number;
    pendingFulfillment: number; // maps to InventoryRow.committed
    fulfilled: number;
    returned: number;
    canceled: number;
    unavailable: number;
    purchased: number;
    status: string;
    createdAt: string;
}

export interface WareCatalogItemInventory {
    id: ID;
    available: number;
    oversellPolicy: OversellPolicy;
    inventoryLots: InventoryLot[];
}

// Shape of a single item from GET /catalogItems?object=ware_catalog_item&expand=inventory.inventoryLots
export interface WareCatalogItem {
    id: ID;
    name: string;
    sku: string;
    status: string;
    product: { id: ID; name?: string }; // name present when the catalog-item fetch expands `product`
    seller: { id: ID };
    inventory?: WareCatalogItemInventory;
    medias?: Array<{ src: string }>;
    deletedAt?: string;
}

// Flat view-model for each AG Grid row.
export interface InventoryRow {
    id: ID; // InventoryLot.id from the first lot in inventoryLots (or WareCatalogItem.id as fallback)
    catalogItemId?: ID; // WareCatalogItem.id (the variant), used for its ware_catalog_item audit ledger
    productId: ID;
    productName: string;
    variantLabel: string; // e.g. "Large (L) / White / Cotton"
    sku: string;
    thumbnailUrl?: string;
    productPhotoId?: string;
    isDeleted: boolean;
    isDraft?: boolean;
    unavailable: number;
    committed: number; // pendingFulfillment
    available: number; // available
    onHand: number; // available + committed
}
